import { priceFormatFinancial } from 'models/shared/helpers/prices';
import {
	CreditPolicyMop,
	CreditPolicyOutcome,
	CreditPolicyOverdueBalance,
} from '../interfaces/credit-policy.interface';

export const formatMopRange = (mop?: CreditPolicyMop): string => {
	if (!mop) return 'Sin buró';
	const min = mop.min ? `MOP >= ${mop.min}` : '';
	const max = mop.max ? `MOP < ${mop.max}` : '';

	if (min !== '' && max !== '') {
		return `${min} · ${max}`;
	}
	return `${min}${max}`;
};

export const formatOverdueBalance = (
	overdueBalance?: CreditPolicyOverdueBalance,
): string => {
	if (!overdueBalance) return '';
	if (overdueBalance.max !== undefined) {
		return ` · SV < ${overdueBalance.max}`;
	}
	if (overdueBalance.min !== undefined) {
		return ` · SV ≥ ${overdueBalance.min}`;
	}
	return '';
};

export const formatOutcomeRange = (outcome?: CreditPolicyOutcome): string => {
	if (!outcome) return '';
	if (outcome.max !== undefined) {
		return ` · CPM < ${priceFormatFinancial(outcome.max)}`;
	}
	if (outcome.min !== undefined) {
		return ` · CPM ≥ ${priceFormatFinancial(outcome.min)}`;
	}
	return '';
};
